import React from "react";

export function renderValidElement<
  T extends keyof React.JSX.IntrinsicElements,
>(args?: {
  props?: React.ComponentProps<T>;
  element?: string | React.ReactNode;
  fallback?: string | React.ReactNode;
}) {
  if (!args) return null;
  const { element, fallback } = args;
  if (React?.isValidElement(element)) {
    const elementProps = element.props as Record<string, unknown>;
    return React.createElement(
      element.type,
      { ...args?.props, ...elementProps },
      elementProps.children as React.ReactNode,
    );
  }
  if (React.isValidElement(fallback)) {
    const fallbackProps = fallback.props as Record<string, unknown>;
    return React.createElement(
      fallback.type,
      { ...fallbackProps, ...args?.props },
      element || (fallbackProps?.children as React.ReactNode),
    );
  }
  return element || fallback || null;
}
